const en = {
    menu_home: "Home",
    menu_SpeRetrieve: "Special Retrieve",
    menu_CLCRetrieve: "CLC Retrieve",
    menu_AdvanceRetrieve: "Advance Retrieve",
    menu_BookMarkRetrieve: "Bookmark Retrieve",
    menu_Notes: "Bullition",
    menu_Mylibray: "My Library",

    field_hit: 'hits',
    field_author: 'author',
    field_pubdate: 'publish date',
    field_content: 'content',
    field_pages: 'pages',
    field_publisher: 'publisher',
    field_clcno: 'clc NO.',
    field_price: 'price',
    
    field_begdate:'begdate',
    field_title: 'title',
    field_callno: 'call number',
    field_subject: 'subject word',
    field_pubyear: 'year of publication',
    field_anyword: "any word",

    field_frontMatch: "front match",
    field_exactMatch: "eact match",
    field_fuzzyRetrieve: "fuzzy retrieve",

    field_labelOrder: "order by",
    field_orderAsc: "asc",
    field_orderDesc: "desc",

    field_tipInputKeyword: "please enter the keyword you want to search",
    field_retrieve: "retrieve",
    field_retrieveInReult: "retrieve in result",

    field_recordsPerPage: "display per page",
    field_clc: "clc NO",
    field_docType: "document type",
    field_language: "language",

    detail_instance_author:'author',
    detail_instance_Ethan:"Ethan",
    detail_instance_publicationInformation:"publicationInformation",
    detail_instance_Pages:"Pages",
    detail_instance_classificationNumber:"classificationNumber",
    detail_instance_bookType:"bookType",
    detail_instance_Books:"books",
    detail_instance_periodical:"periodical",
    detail_instance_keyword:"keywords",
    detail_instance_seriesTitle:"seriesTitle",
    detail_instance_relatedResources:"relatedResources",
    detail_instance_version:"version",
    detail_instance_address:'address',
    detail_instance_pub_date:'pub_date',
    detail_instance_price:'price',
    detail_instance_publish:'publish',

    PageHoldingList_claimNumber:'claimNumber',
    PageHoldingList_place:'place',
    PageHoldingList_circulationCategory:'circulationCategory',
    PageHoldingList_barcode:'barcode',
    
    ItemTab_pages:'pages',
    ItemTab_size:'size',

    Bookshelf_delete:'delete',
    Bookshelf_recordNumber:'recordNumber',
    Bookshelf_title:'title', 
    Bookshelf_author:'author',
    Bookshelf_publish:'publish',
    Bookshelf_pubDay:'pubDay',
    Bookshelf_price:'price',
    Bookshelf_state:'state',
    Bookshelf_addBookshelfTime:'addBookshelfTime',

    Loanlist_confirmRenewal:'confirmRenewal',
    Loanlist_cenewAllLoans:'cenewAllLoans',
    Loanlist_title:'title',
    Loanlist_collectionLocationName:'collectionLocationName',
    Loanlist_LocationName:'LocationName',
    Loanlist_borrowingDate:'borrowingDate',
    Loanlist_returnDate:'returnDate',
    Loanlist_ISBN:'ISBN',
    Loanlist_bookType:'bookType',
    Loanlist_borrowingsNumber:'borrowingsNumber',
    Loanlist_barcode:'barcode',
    Loanlist_renewalResult:'renewalResult',

    Loglist_query:'query',
    Loglist_borrowOrRepayamount:'borrowOrRepayamount',
    Loglist_operationType:'operationType',
    Loglist_dateRange:'dateRange',
    Loglist_per_recordNumber:'per_recordNumber',
    Loglist_enterAnInquiry:'Please enter an inquiry',
    Loglist_loanDate:'loanDate',
    Loglist_dueDate:'dueDate',
    Loglist_barcode:'barcode',
    Loglist_title:'title',
    Loglist_lendingLocation:'lendingLocation'
};

export default en;